import { render, staticRenderFns } from "./CorporateCodes.vue?vue&type=template&id=7f224bc0&scoped=true&"
import script from "./CorporateCodes.vue?vue&type=script&lang=js&"
export * from "./CorporateCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f224bc0",
  null
  
)

export default component.exports